import React, {useState} from "react";
import Modal from "react-modal";
import {FaTimes} from "react-icons/fa";
import {
  createMultiConfirmacionNaviera,
  getAllContainersCNaviera
} from "../../../../../helpers/Api";
import Swal from "sweetalert2";
import {CampoSelectAsync} from "../../../../../helpers/CampoSelectAsync";
import TempFileUploader from "../../../../../helpers/TempFileUploader";
import useToggle from "../../../../../hooks/UseToggle";

const ConformacionNaviera = ({
  idSolicitud,
  closeModal, handlerGetAllContainersCNaviera
}) => {

  const [file, setFile] = useState('');
  const [contenedores, setContenedores] = useState([]);
  const [todosContenedores, setTodosContenedores] = useToggle(true);

  const handlerCreateCorte = async () => {
    try {
      const data = {
        todos_contenedores: todosContenedores,
        contenedores: contenedores.map((x) => x.value),
        confirmacion_naviera_archivo: file
      }
      const response = await createMultiConfirmacionNaviera(idSolicitud, data);
      if (response.status === 200) {
        Swal.fire("Exito", "La confirmación de naviera fue creado con éxito", "success");
        closeModal();
        setTimeout(() => {
          window.location.reload();
        }, "1000");

      }else{
        Swal.fire("Oops",
          `Ha surgido un problema al cargar la confirmación de naviera, <br />
          Consejo: ${JSON.stringify(response.data)}
      `,
          "error");
      }
    } catch (error) {
      Swal.fire("Oops", "Ha surgido un error", "error");
    }
  };

  return (
    <>
      <div className="row d-flex justify-content-center">
        <div className="col-8">
          <h6 className='mb-5'>
            Ingrese la información requerida referente a la confirmación de la naviera
          </h6>
        </div>
        <div className='col-8'>
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              checked={todosContenedores}
              onClick={() => setTodosContenedores()}
            />
            <label className="form-check-label" style={{fontSize: '14px'}}
                   htmlFor="flexSwitchCheckChecked">
              Todos los contenedores
            </label>
          </div>
        </div>
        <div className="col-8 mt-3">
          <label className="form-label">
            Contenedores
          </label>
          <CampoSelectAsync
            blank={true}
            name="contenedores"
            fieldShow="numero"
            isMulti={true}
            disabled={todosContenedores}
            selectedValue={contenedores}
            remoteCall={handlerGetAllContainersCNaviera}
            onChange={(key, value) => {
              setContenedores(value)
            }}
            placeholder="Seleccionar contenedores"/>
        </div>
        <hr className={"mt-5"}/>
        <div className="col-10 mt-5">
          <TempFileUploader
            setFile={setFile}
            idSolicitud={idSolicitud}
          />
        </div>
        <div className="col-8 d-flex flex-row-reverse mt-4">
          <button onClick={() => handlerCreateCorte()}
                  disabled={file===""}
                  className="btn btn-primary">Guardar
          </button>
        </div>
      </div>
    </>
  );
};

const ModalMultiDemoras = ({
                             idSolicitud,
                             modalIsOpen,
                             closeModal,
                           }) => {


  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      width: "60%",
      height: "70%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      backgroundColor: "#ffff",
      borderRadius: "5px",
    },
  };

  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      style={customStyles}
      contentLabel="Example Modal"
      ariaHideApp={false}
    >
      <div className="row m-1">
        <div className="col-12  d-flex flex-row-reverse">
          <button className="btn" onClick={closeModal}>
            <FaTimes style={{ color: "#F47777" }} />
          </button>
        </div>
      </div>
      <div className="row d-flex justify-content-center">
        <div className="col-10 mt-5">
        <ConformacionNaviera
         idSolicitud={idSolicitud}
         closeModal={closeModal}
         handlerGetAllContainersCNaviera={(search, offset, limit)=>{
           return getAllContainersCNaviera(idSolicitud, search, offset, limit)
         }}
         />
         </div>
        </div>
    </Modal>
  );
};

export default ModalMultiDemoras;
